import { useUrlState } from '@round/utils';

type UrlState = {
    clSearch: string;
};

export default function useCreditLimitsUrlState() {
    const { url, mergeSearchParams } = useUrlState<UrlState>();

    return [url.searchParams, mergeSearchParams] as const;
}
